import React from 'react';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import LTC from '../../../../Quoters/LTC/LTC';

export default function LTCData() {
  const minAge = 18;
  const maxAge = 79;
  const minCoverageAmount = 100000;
  const maxCoverageAmount = 10000000;

  return {
    name: 'Long Term Care',
    subtitle: 'Asset Protection',
    footerMessage: "Get peace of mind and long term care insurance",
    footerButtonName: "Contact Our Team",
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    basicInfoForm: () => {
      return <LTC landing />;
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(maxAge),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [0, 2, 3],
    faq: FaqData()
  }
}
